import React, { useState, useEffect, useRef } from "react";
import "./About.css";
import Header from "../Header/Header";
import SEO from '../SEO/SEO';
import Footer from "../Footer/Footer";
import defaultBannerImage from "../Assets/About/about-us-banner-img.png";
import MissionIcon from "../Assets/About/workshop-icon-1.png";
import VisionIcon from "../Assets/About/workshop-icon-2.png";
import leadershipIcon from "../Assets/About/leadership.png";
import responsibilityIcon from "../Assets/About/responsibility.png";
import tractionIcon from "../Assets/About/Traction.png";
import expertiseIcon from "../Assets/About/Traction.png";
import Google from "../Assets/Google.png";
import { Link } from "react-router-dom";

import api, { PUBLIC_BASE_URL, BASE_URL } from "../Api/api";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

const About = () => {
  const [scrollIndex, setScrollIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3);
  const scrollRef = useRef();
  const CARD_WIDTH = 300 + 16; // width + margin

  useEffect(() => {
    const updateVisibleCards = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setVisibleCards(1);
      } else if (width < 768) {
        setVisibleCards(1);
      } else if (width < 992) {
        setVisibleCards(2);
      } else {
        setVisibleCards(3);
      }
    };

    updateVisibleCards();
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  const scroll = (direction) => {
    const maxIndex = Math.ceil(testimonials.length / visibleCards) - 1;
    let newIndex = scrollIndex;

    if (direction === "left") {
      newIndex = Math.max(0, scrollIndex - 1);
    } else if (direction === "right") {
      newIndex = Math.min(maxIndex, scrollIndex + 1);
    }

    setScrollIndex(newIndex);

    if (scrollRef.current) {
      scrollRef.current.style.transform = `translateX(-${
        newIndex * CARD_WIDTH * visibleCards
      }px)`;
    }
  };

  const renderStars = (count) =>
    Array.from({ length: count }, (_, i) => (
      <b key={i} className="fa-solid fa-star" style={{ color: "gold" }}>
        ★
      </b>
    ));

  const [testimonials, setTestimonials] = useState([]);
  const [reviewCount, setReviewCount] = useState(null);
  const [bannerImage, setBannerImage] = useState(defaultBannerImage);
  const [about, setAbout] = useState(null);
  const [ceoData, setCeoData] = useState(null);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    api
      .get("service-cities")
      .then((response) => {
        setCities(response.data);
      })
      .catch((error) => {
        console.error("Error fetching service cities:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch testimonials
    const fetchTestimonials = api.get("testimonials");

    // Fetch review count
    const fetchReviewCount = api.get("google-review-count");

    // Fetch about banner
    const fetchBanner = api.get("about-hero-banner");

    // Fetch about section
    const fetchAbout = api.get("about-section");

    // Fetch CEO section
    const fetchCeo = api.get("ceosection");

    Promise.all([
      fetchTestimonials,
      fetchReviewCount,
      fetchBanner,
      fetchAbout,
      fetchCeo,
    ])
      .then(([testimonialsRes, reviewRes, bannerRes, aboutRes, ceoRes]) => {
        // Testimonials
        if (testimonialsRes.data?.testimonials) {
          setTestimonials(testimonialsRes.data.testimonials);
        }

        // Google review count
        if (reviewRes.data?.review_count !== undefined) {
          setReviewCount(reviewRes.data.review_count);
        }

        // Banner image
        if (bannerRes.data?.image) {
          setBannerImage(`${PUBLIC_BASE_URL}${bannerRes.data.image}`);
        } else {
          console.warn("No banner image found:", bannerRes.data);
        }

        // About section
        if (aboutRes.data) {
          setAbout(aboutRes.data);
        }

        // CEO section
        if (ceoRes.data) {
          setCeoData(ceoRes.data);
        } else {
          console.warn("Empty ceosection response:", ceoRes);
        }
      })
      .catch((error) => {
        console.error("Error loading data in About page:", error);
      });
  }, []);

  return (
    <div>
      <SEO />
      <Header />
      <section
        className="hero-section py-5 text-white text-center"
        style={{
          background: `url(${bannerImage || defaultBannerImage}) center/cover`,
          height: "100vh",
        }}
      >
        <div className="container" style={{ marginTop: "150px" }}>
          <h2 className="display-5 fw-bold mt-5">About Us</h2>
          <p>Home / About Us</p>
        </div>
      </section>

      <section className="py-5 about-section text-dark">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Left Image */}
            <div className="col-lg-5">
              {/* <img
              src={`http://127.0.0.1:8000${about.image}`}
              alt="About Us"
              className="img-fluid rounded shadow-lg"
            /> */}

              {about?.image && (
                <img
                  src={`${BASE_URL}${about.image}`}
                  alt="About"
                  className="img-fluid rounded shadow-lg"
                />
              )}
            </div>

            {/* Right Content */}
            <div className="col-lg-7" style={{ textAlign: "center" }}>
              <p className="text-primary text-uppercase fw-semibold mb-2 small letter-spacing-sm">
                — More Than Clean—It’s Shiny Clean
              </p>
              <h2 className="mb-4 fw-bold display-6">{about?.heading}</h2>

              {/* Dynamic Paragraphs */}
              {about &&
                about.paragraphs &&
                about.paragraphs.map((para, index) => (
                  <p key={index}>{para}</p>
                ))}

              {/* Mission & Vision */}
              <div className="row g-4 mt-4">
                <div className="col-md-6">
                  <div className="info-box h-100 p-4 shadow-sm">
                    <div className="d-flex align-items-start mb-3">
                      <img
                        src={MissionIcon} // replace with your icon path
                        alt="Mission Icon"
                        width="40"
                        className="me-3"
                      />
                      <h6 className="m-0">Our Mission</h6>
                    </div>
                    {about && <p style={{ textAlign: "center" }}>{about.mission}</p>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="info-box h-100 p-4 shadow-sm">
                    <div className="d-flex align-items-start mb-3">
                      <img
                        src={VisionIcon} // replace with your icon path
                        alt="Vision Icon"
                        width="40"
                        className="me-3"
                      />
                      <h6 className="m-0">Our Vision</h6>
                    </div>
                    {/* <p>{about.vision}</p> */}
                    {about && <p style={{ textAlign: "center" }}>{about.vision}</p>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {ceoData && (
        <section className="ceo-section">
          <div className="container ceo-container">
            <div className="ceo-content">
              {/* Text Column */}
              <div className="ceo-text" style={{ textAlign: "center" }}>
                <h2 className="ceo-title">{ceoData.heading}</h2>

                <p
                  className="ceo-description"
                  dangerouslySetInnerHTML={{
                    __html: ceoData.paragraph_1?.replace(/\n/g, "<br />"),
                  }}
                />
                <p
                  className="ceo-description"
                  dangerouslySetInnerHTML={{
                    __html: ceoData.paragraph_2?.replace(/\n/g, "<br />"),
                  }}
                />

                <div className="ceo-icons">
                  {[
                    { img: leadershipIcon, label: "Leadership" },
                    { img: tractionIcon, label: "Traction" },
                    { img: responsibilityIcon, label: "Responsibility" },
                    { img: expertiseIcon, label: "Expertise" },
                  ].map((item, index) => (
                    <div className="ceo-icon" key={index}>
                      <div className="icon-circle">
                        <img src={item.img} alt={item.label} />
                      </div>
                      <p>{item.label}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Image Column */}
              <div className="ceo-image">
                <div className="ceo-image-wrapper">
                  <img
                    src={`${PUBLIC_BASE_URL}${ceoData.image}`}
                    alt={`CEO ${ceoData.heading}`}
                  />
                  <div className="ceo-name-badge">{ceoData.heading}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="ceo-wave"></div>
        </section>
      )}

      <section className="py-5 bg-light" id="service-cities">
        <div className="container">
          <div className="text-center mb-5">
            <h3 style={{ color: "#002060", fontSize: "32px", fontWeight: 600 }}>
              Now Serving Two Cities with Pride
            </h3>
          </div>
          <div className="row g-4">
            {cities.map((city, index) => (
              <div className="col-md-6" key={index}>
                <div className="city-card h-100 p-3 rounded shadow-sm bg-white text-center">
                  <img
                    src={`${PUBLIC_BASE_URL}${city.image}`}
                    alt={city.heading}
                    className="img-fluid rounded mb-3"
                  />
                  <h5>{city.heading}</h5>
                  <ul className="list-unstyled mb-0">
                    <li>✔{city.line1}</li>
                    <li>✔{city.line2}</li>
                  </ul>
                  <Link
                    to={city.button_link}
                    className="btn btn-outline-primary mt-3"
                    style={{ borderRadius: "30px" }}
                  >
                    {city.button_text || "View More"}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="testimonials-section">
        <div className="container">
          <div className="section-header text-center mb-4">
            <p className="subheading">— Testimonials</p>
            <h2>Client Testimonies: Experience with Our Cleaners</h2>
          </div>

          <div className="row">
            {/* Left Summary */}
            <div className="col-lg-3 col-md-4 mb-4 text-center review-summary">
              <p className="rating-label m-0 fw-bold fs-5">EXCELLENT</p>
              <div className="stars">{renderStars(5)}</div>
              <p>
                Based on{" "}
                <strong>{reviewCount !== null ? reviewCount : "..."}</strong>{" "}
                reviews
              </p>
              <img
                src={Google}
                alt="Google"
                style={{ width: "100px", marginTop: "-10px" }}
              />
            </div>

            {/* Testimonials Scrollable */}
            <div className="col-lg-9 col-md-8 position-relative testimonial-scroll-wrapper">
              <div className="testimonial-scroll d-flex" ref={scrollRef}>
                {testimonials.map((item, index) => (
                  <div
                    key={index}
                    className="testimonial-card p-3 mx-2 bg-white rounded shadow"
                  >
                    <div className="card-header d-flex align-items-center mb-2">
                      {item.avatar ? (
                        <img
                          src={`${PUBLIC_BASE_URL}${item.avatar}`}
                          className="avatar-img me-2 rounded-circle"
                          alt={item.name}
                          style={{ width: 40, height: 40 }}
                        />
                      ) : (
                        <div className="avatar me-2">
                          {item.name?.charAt(0)}
                        </div>
                      )}
                      <div>
                        <h5 className="mb-0">{item.name}</h5>
                        <small>{item.date}</small>
                      </div>
                      <img
                        src={`${PUBLIC_BASE_URL}${item.platform}`}
                        alt="Platform"
                        style={{ width: 16, marginLeft: "auto" }}
                      />
                    </div>

                    <div className="rating mb-2">
                      {renderStars(item.rating)}
                      {item.verified && (
                        <img
                          src={`${PUBLIC_BASE_URL}${item.verified}`}
                          alt="verified"
                          style={{
                            width: 16,
                            marginLeft: "6px",
                            verticalAlign: "middle",
                          }}
                        />
                      )}
                    </div>

                    <p className="comment-truncate m-0">{item.comment}</p>
                  </div>
                ))}
              </div>

              {/* Arrow Controls */}
              <div className="d-flex justify-content-center gap-2 scroll-controls">
                <button
                  onClick={() => scroll("left")}
                  className="scroll-arrow left-arrow"
                >
                  <FaChevronLeft />
                </button>
                <button
                  onClick={() => scroll("right")}
                  className="scroll-arrow right-arrow"
                >
                  <FaChevronRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
